import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_SERVICES_SAGA } from "../sagaTypes";
import { loadingAction, setScheduleAction } from '../actions.js';
import { url } from "../../config";
import { toast } from 'react-hot-toast';

const request = data => {
    return fetch(`${ url }/get_services`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetServices(args) {
    const est = yield select(state => state.est);
    const user = yield select(state => state.user);
    const schedule = yield select(state => state.schedule);

    yield put(loadingAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('user_hash', user.hash);
        formData.append('establishment', est.id);
        formData.append('date', schedule.date);
        formData.append('time', schedule.selected_time);
        formData.append('master', schedule.selected_master);

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.success) {
            yield put(setScheduleAction({
                ...schedule,
                open: true,
                stage: response.data.stage,
                services: response.data.services,
                max_service_duration_by_master: response.data.max_service_duration_by_master,
                all_master_services: response.data.all_master_services
            }));
        }
        else if (response.error) {
            toast.error(response.message);
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        yield put(loadingAction(false));
    }
}

export default function* watcherGetServices() {
    yield takeLatest(GET_SERVICES_SAGA, workerGetServices);
}